import { Department } from '../../core/models/peru-location.model';
import { DropdownOption } from '../models/form-controls.model';

export function getDepartmentOptions(
  departments: Department[]
): DropdownOption<string>[] {
  return departments.map(d => ({
    label: d.label,
    value: d.value,
  }));
}

export function getProvinceOptions(
  departments: Department[],
  departmentName: string
): DropdownOption<string>[] {
  const department = departments.find(d => d.value === departmentName);
  if (!department) return [];
  return department.provinces.map(p => ({
    label: p.label,
    value: p.value,
  }));
}

export function getDistrictOptions(
  departments: Department[],
  departmentName: string,
  provinceName: string
): DropdownOption<string>[] {
  const department = departments.find(d => d.value === departmentName);
  const province = department?.provinces.find(p => p.value === provinceName);
  if (!province) return [];
  return province.districts.map(d => ({
    label: d.label,
    value: d.value,
  }));
}
